<template>
  <div>
    <div class="curriculumPage_main">
      <div class="curriculumPage_main_page">
        <!-- Page left -->
        <div class="curriculumPage_main_left" :class="[{noActiveMobile: isContent}]" v-show="!disableMenu">
          <div class="title-h1">{{ materialInfo.chapterName }}</div>
          <div class="notebook_catalogue">
            <ul class="nav_ul">
              <li class="nav_ul_li" :class="{ notebook_catalogue_active: item_show == $CONST.VIDEO.CONTENT_TYPE.MENU }" @click="item_show = $CONST.VIDEO.CONTENT_TYPE.MENU">
                <span>{{ $t("read.catalogue") }}</span>
              </li>
              <li class="nav_ul_li" :class="{ notebook_catalogue_active: item_show == $CONST.VIDEO.CONTENT_TYPE.NOTEBOOK }" @click="item_show = $CONST.VIDEO.CONTENT_TYPE.NOTEBOOK">
                <span>{{ $t("read.note") }}</span>
              </li>
              <li class="nav_ul_li" :class="{ notebook_catalogue_active: item_show == $CONST.VIDEO.CONTENT_TYPE.MESSENGER }" @click="showBoxMessage()">
                <span>{{ $t("read.chat") }}</span>
              </li>
            </ul>
            <!-- Close Menu -->
            <button class="closeMenu" @click="tooggleMenuMobile()">X</button>
            <!-- Content page left -->
            <template>
              <!-- NOTEBOOK -->
              <div v-if="item_show == $CONST.VIDEO.CONTENT_TYPE.NOTEBOOK" class="notebook_fill">
                <textarea :placeholder="$t('read.tips')" class="notebook_input" v-model="note" style="resize: none"></textarea>
                <div class="lesson_page"><p></p></div>
                <p class="save_btn">
                  <button @click="saveNote">{{ $t("read.save") }}</button>
                </p>
              </div>
              <!-- MESSENGER -->
              <div v-else-if="item_show == $CONST.VIDEO.CONTENT_TYPE.MESSENGER" class="messenger_fill">
                <div class="chat-box">
                  <template v-for="(item, index) in chats">
                    <div class="content-message" :key="index">
                      <div class="msg" :class="[{ 'f-right': item.userType == $CONST.VIDEO.CHAT.USER_TYPE.ME }, { 'f-left': item.userType == $CONST.VIDEO.CHAT.USER_TYPE.ORTHER }, { 'f-teacher': item.userType == $CONST.VIDEO.CHAT.USER_TYPE.TEACHER }]">
                        <div class="avt">
                          <template v-if="item.portraitPath == null">
                            <img src="../../../static/images/profile.jpg" alt="default">
                          </template>
                          <template v-else>
                            <img :src="item.portraitPath"/>
                          </template>
                        </div>
                        <div class="n-ms">
                          <p class="name nqt--name-chat" v-show="item.userType != $CONST.VIDEO.CHAT.USER_TYPE.ME">{{ item.name }}</p>
                          <p class="message">{{ item.commentContent }}</p>
                          <div class="time">
                            <span>{{item.updateDate}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="fab_field">
                  <input type="text" name="chat_message" @keyup.enter="sendMessage" id="chatSend" v-model="message" placeholder="..." class="chat_field chat_message"/>
                  <button class="send btn-tast xoay" @click="sendMessage()">
                    <img src="../../../static/images/send-xanh.png"/>
                  </button>
                </div>
              </div>
              <!-- MENU -->
              <div class="catalogue_box" v-else>
                <ul class="active">
                  <template v-for="(item1, index1) in data">
                    <li :class="[{ noTitle: item1.thirdOutlineList == null }, { activeTitle: item1.id == activeID }]" :key="index1">
                      <template v-if="item1.thirdOutlineList == null">
                        <template v-if="item1.learningState == $CONST.VIDEO.MENU.LEARNING_COMPLETED && parseInt(item1.passingRateQuiz)<=item1.scoreNew">
                          <img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/>
                        </template>
                        <template v-else-if="item1.learningState == $CONST.VIDEO.MENU.LEARNING || item1.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item1.passingRateQuiz)>item1.scoreNew">
                          <img class="img-bh" src="../../../static/images/baihoc-do.png"/>
                        </template>
                        <template v-else>
                          <img class="img-bh" src="../../../static/images/baihoc-den.png"/>
                        </template>
                      </template>
                      <span :class="[{ caret: item1.thirdOutlineList != null }, { nqtCn: item1.thirdOutlineList == null }]" class="caret-down" @click="item1.thirdOutlineList == null ? jumpToLesson(item1, {}, {}, {}, {}, item1) : toggleClass($event, item1.id)">{{ item1.chapterName }}</span>
                      <ul :class="[{ nested: item1.thirdOutlineList != null }, { active: activeMenu == item1.id }]">
                        <li v-for="(item2, index2) in item1.thirdOutlineList" :class="[{ noTitle: item2.thirdOutlineList == null }, { activeTitle: item2.id == activeID }]" :key="index2">
                          <template v-if="item2.thirdOutlineList == null">
                            <template v-if="item2.learningState == $CONST.VIDEO.MENU.LEARNING_COMPLETED && parseInt(item2.passingRateQuiz)<=item2.scoreNew">
                              <img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/>
                            </template>
                            <template v-else-if="item2.learningState == $CONST.VIDEO.MENU.LEARNING || item2.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item2.passingRateQuiz)>item2.scoreNew">
                              <img class="img-bh" src="../../../static/images/baihoc-do.png"/>
                            </template>
                            <template v-else>
                              <img class="img-bh" src="../../../static/images/baihoc-den.png"/>
                            </template>
                          </template>
                          <span :class="[{ caret: item2.thirdOutlineList != null }, { nqtCn: item2.thirdOutlineList == null }]" class="caret-down" @click="item2.thirdOutlineList == null ? jumpToLesson(item1, item2, {}, {}, {}, item2) : toggleClass($event, item1.id)">{{ item2.chapterName }}</span>
                          <ul :class="[{ nested: item2.thirdOutlineList != null }]" class="active">
                            <li v-for="(item3, index3) in item2.thirdOutlineList" :class="[{ noTitle: item3.thirdOutlineList == null }, { activeTitle: item3.id == activeID }]" :key="index3">
                              <template v-if="item3.thirdOutlineList == null">
                                <template v-if="item3.learningState == $CONST.VIDEO.MENU.LEARNING_COMPLETED && parseInt(item3.passingRateQuiz)<=item3.scoreNew">
                                  <img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/>
                                </template>
                                <template v-else-if="item3.learningState == $CONST.VIDEO.MENU.LEARNING || item3.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item3.passingRateQuiz)>item3.scoreNew">
                                  <img class="img-bh" src="../../../static/images/baihoc-do.png"/>
                                </template>
                                <template v-else>
                                  <img class="img-bh" src="../../../static/images/baihoc-den.png"/>
                                </template>
                              </template>
                              <span :class="[{ caret: item3.thirdOutlineList != null }, { nqtCn: item3.thirdOutlineList == null }]" class="caret-down" @click="item3.thirdOutlineList == null ? jumpToLesson(item1, item2, item3, {}, {}, item3) : toggleClass($event, item1.id)">{{ item3.chapterName }}</span>
                              <ul :class="[{ nested: item3.thirdOutlineList != null }]" class="active">
                                <li v-for="(item4, index4) in item3.thirdOutlineList" :class="[{ noTitle: item4.thirdOutlineList == null }, { activeTitle: item4.id == activeID }]" :key="index4">
                                  <template v-if="item4.thirdOutlineList == null">
                                    <template v-if="item4.learningState == $CONST.VIDEO.MENU.LEARNING_COMPLETED && parseInt(item4.passingRateQuiz)<=item4.scoreNew">
                                      <img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/>
                                    </template>
                                    <template v-else-if="item4.learningState == $CONST.VIDEO.MENU.LEARNING || item4.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item4.passingRateQuiz)>item4.scoreNew">
                                      <img class="img-bh" src="../../../static/images/baihoc-do.png"/>
                                    </template>
                                    <template v-else>
                                      <img class="img-bh" src="../../../static/images/baihoc-den.png"/>
                                    </template>
                                  </template>
                                  <span :class="[{ caret: item4.thirdOutlineList != null }, { nqtCn: item4.thirdOutlineList == null }]" class="caret-down" @click="item4.thirdOutlineList == null ? jumpToLesson(item1, item2, item3, item4, {}, item4) : toggleClass($event, item1.id)">{{ item4.chapterName }}</span>
                                  <ul :class="[{ nested: item4.thirdOutlineList != null }]" class="active">
                                    <li v-for="(item5, index5) in item4.thirdOutlineList" :class="[ { noTitle: item5.thirdOutlineList == null }, { activeTitle: item5.id == activeID }]" :key="index5">
                                      <template v-if="item5.thirdOutlineList == null">
                                        <template v-if="item5.learningState == $CONST.VIDEO.MENU.LEARNING_COMPLETED && parseInt(item5.passingRateQuiz)<=item5.scoreNew">
                                          <img class="img-bh" src="../../../static/images/baihoc-xanhla.png"/>
                                        </template>
                                        <template v-else-if="item5.learningState == $CONST.VIDEO.MENU.LEARNING || item5.learningState == $CONST.MENU.LEARNING_COMPLETED && parseInt(item5.passingRateQuiz)>item5.scoreNew">
                                          <img class="img-bh" src="../../../static/images/baihoc-do.png"/>
                                        </template>
                                        <template v-else>
                                          <img class="img-bh" src="../../../static/images/baihoc-den.png"/>
                                        </template>
                                      </template>
                                      <span :class="[{ caret: item5.thirdOutlineList != null }, { nqtCn: item5.thirdOutlineList == null }]" @click="item5.thirdOutlineList == null ? jumpToLesson(item1, item2, item3, item4, item5, item5) : toggleClass($event, item1.id)">{{ item5.chapterName }}</span>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </template>
                </ul>
              </div>
            </template>
            <!--  -->
            <div class="nqt_a_l" v-if="!mobile && !disableMenu" @click="disableMenu = true">
              <button class="nqt_close_menu">&#8810;</button>
            </div>
          </div>
        </div>
        <!-- Page content -->
        <template v-for="(item, index) in materialInfo.materialList">
          <div v-if="phaseActive == item.id" class="curriculumPage_right" :class="[{noActiveMobile: !isContent}, {nqt_disableMenu: disableMenu && !mobile}]" id="curriculumPage_right" :key="index">
            <div class="lesson_page_pdf div-btn-icon pdf-pc">
              <template v-show="loadControl">
                <button class="btn-tast btn-next-1" @click="goto_lesson">
                  <img src="../../../static/images/icon-back-1.png"/>
                  <span class="nqt-text">{{ $t("common.returnButton") }}</span>
                </button>
                <!--  -->
                <template v-if="item.materialType == $CONST.VIDEO.MATERIAL.TYPE.PDF">
                  <button class="btn-tast btn-next-1" @click="value != 0 ? value -=5 : false">
                    <img v-if="value == 0" src="../../../static/images/zoom-den-tru.png"/>
                    <img v-else src="../../../static/images/zoom-xanh-tru.png"/>
                  </button>
                  <button class="btn-tast btn-next-1" @click="value != 100 ? value +=5 : false">
                    <img v-if="value == 100" src="../../../static/images/zoom-den-cong.png"/>
                    <img v-else src="../../../static/images/zoom-xanh-cong.png"/>
                  </button>
                </template>
                <!--  -->
                <button class="btn-tast" :class="[{ 'btn--none': isPage == 1 && materialInfo.preOutlineId == null }, {hiddenControl: !showControl}]" @click="materialInfo.preOutlineId != null || isPage != 1 ? prevPage() : false">
                  <template>
                    <template v-if="isPage == 1 && materialInfo.preOutlineId == null">
                      <img src="../../../static/images/back-den.png"/>
                    </template>
                    <template v-else>
                      <img src="../../../static/images/icon-back.png"/>
                    </template>
                  </template>
                  <span>{{$t("errorBook.prve")}}</span>
                </button>
                <div class="pages-number" :class="[{hiddenControl: !showControl}]">
                  <span class="pgn">{{ isPage }}/{{ pageCount }}</span>
                  <div class="select-new select-custom">
                    <select v-model="isPage" @input="jumpPage()">
                      <option v-for="(opt, indexP) of maxSelect" :value="opt" :key="indexP">
                        {{opt}}
                      </option>
                    </select>
                  </div>
                </div>
                <button class="btn-tast xoay" :class="[{ 'btn--none': materialInfo.nextOutlineId == null && isPage >= pageCount }, {hiddenControl: !showControl}]" @click="materialInfo.nextOutlineId != null || isPage < pageCount ? nextPage() : false">
                  <template>
                    <template v-if="materialInfo.nextOutlineId == null && isPage >= pageCount">
                      <img src="../../../static/images/back-den.png"/>
                    </template>
                    <template v-else>
                      <img src="../../../static/images/icon-back.png"/>
                    </template>
                  </template>
                  <span class="nqt-text">{{ $t("errorBook.next") }}</span>
                </button>
                <button class="btn-tast" :class="[{hiddenControl: !showControl}]" v-show="item.exerciseState == $CONST.VIDEO.MENU.HAVE_EXERCISE && item.isExercise != $CONST.VIDEO.MENU.EXERCISE_NONE" @click="goExc()">
                  <img src="../../../static/images/icon-bt.png"/>
                  <span class="nqt-text">{{ $t("week.exercise") }}</span>
                </button>
              </template>
            </div>
            <!-- Content -->
            <div class="curriculum_box" id="curriculum_nqt_box_right" @click="mobile && !noEventOnTap && value == 0 && item.materialType != $CONST.VIDEO.MATERIAL.TYPE.VIDEO ? onTap($event) : false">
              <div class="curriculum_box_main" v-if="loadContent">
                <div class="curriculum_img" id="div-right" ref="nqt-content">
                  <pdf ref="pdf" v-if="item.materialPath != null && item.materialType == $CONST.VIDEO.MATERIAL.TYPE.PDF && showControl" v-bind="{value, orientation}" :pdfurl="item.id" :firstPage="pageReal" @loadPDF="nqtLoadPDF($event)"></pdf>
                  <img v-if="item.materialPath != null && item.materialType == $CONST.VIDEO.MATERIAL.TYPE.IMG" :src="item.materialPath"/>
                  <img class="no-result-pdf" v-if="item.materialType == $CONST.VIDEO.MATERIAL.TYPE.PDF && !showControl" src="../../../static/images/noresult.jpg"/>
                  <!-- <video
                    v-if="item.materialVideoPath1 != null && item.materialType == $CONST.VIDEO.MATERIAL.TYPE.VIDEO"
                    id="mainVideo"
                    ref="mainVideo"
                    name="media"
                    controls
                    controlslist="nodownload noremoteplayback"
                    :src="item.materialVideoPath1"
                    @contextmenu.prevent="notClickRight"
                    x5-video-player-fullscreen="true"
                  ></video> -->
                  <video-player v-if="item.materialVideoPath1 != null && item.materialType == $CONST.VIDEO.MATERIAL.TYPE.VIDEO && showM3u8" class="vjs-custom-skin" ref="videoPlayer" :options="playerOptions" @ready="onPlayerReadied" @timeupdate="onTimeupdate"></video-player>
                </div>
              </div>
              <loading class="loading--lesson" :showLoading="showLoadingFlg" />
            </div>
            <div class="nqt_a_r" v-if="!mobile && disableMenu" @click="disableMenu = false">
              <button class="nqt_close_menu">&#8811;</button>
            </div>
            <div class="lesson_page_pdf div-btn-icon pdf-mobile">
              <template v-show="loadControl">
                <button class="btn-tast btn-show" @click="goto_lesson">
                  <img src="../../../static/images/icon-back-1.png"/>
                  <span class="nqt-text">{{ $t("common.returnButton") }}</span>
                </button>
                <button class="btn-tast btn-show" :class="[{ 'btn--none': isPage == 1 && materialInfo.preOutlineId == null }, {hiddenControl: !showControl}]" @click="materialInfo.preOutlineId != null || isPage != 1 ? prevPage() : false">
                  <template>
                    <template v-if="isPage == 1 && materialInfo.preOutlineId == null">
                      <img src="../../../static/images/back-den.png"/>
                    </template>
                    <template v-else>
                      <img src="../../../static/images/icon-back.png"/>
                    </template>
                  </template>
                  <span>{{$t("errorBook.prve")}}</span>
                </button>
                <button @click="tooggleMenuMobile()" class="btn-tast btn-show">
                  <img src="../../../static/images/mucluc-xanh.png"/>
                  <span class="nqt-text">{{ $t("read.catalogue") }}</span>
                </button>
                <button class="btn-tast btn-show" :class="[{hiddenControl: !showControl}]" v-show="item.exerciseState == $CONST.VIDEO.MENU.HAVE_EXERCISE && item.isExercise != $CONST.VIDEO.MENU.EXERCISE_NONE" @click="goExc()">
                  <img src="../../../static/images/icon-bt.png"/>
                  <span class="nqt-text">{{ $t("week.exercise") }}</span>
                </button>
                <div class="pages-number nqt-zoom-mn" :class="[{hiddenControl: !showControl}]" v-if="item.materialPath != null && item.materialType == $CONST.VIDEO.MATERIAL.TYPE.PDF && mobile && isContent">
                  <span class="nqt-precent" @click="value = 0">{{getScale(value)}}x</span>
                  <el-slider v-model="value" :step="step"></el-slider>
                  <span class="pgn">{{ isPage }}/{{ pageCount }}</span>
                  <div class="select-new select-custom">
                    <select v-model="isPage" @input="jumpPage()">
                      <option v-for="(opt, indexP) of maxSelect" :value="opt" :key="indexP">
                        {{opt}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="pages-number" v-if="item.materialType != $CONST.VIDEO.MATERIAL.TYPE.PDF && mobile && isContent" :class="[{hiddenControl: !showControl}]">
                  <span class="pgn">{{ isPage }}/{{ pageCount }}</span>
                  <div class="select-new select-custom">
                    <select v-model="isPage" @input="jumpPage()">
                      <option v-for="(opt, indexP) of maxSelect" :value="opt" :key="indexP">
                        {{opt}}
                      </option>
                    </select>
                  </div>
                </div>
                <button class="btn-tast xoay" :class="[{ 'btn--none': materialInfo.nextOutlineId == null && isPage >= pageCount }, {hiddenControl: !showControl}]" @click="materialInfo.nextOutlineId != null || isPage < pageCount ? nextPage() : false">
                  <template>
                    <template v-if="materialInfo.nextOutlineId == null && isPage >= pageCount">
                      <img src="../../../static/images/back-den.png"/>
                    </template>
                    <template v-else>
                      <img src="../../../static/images/icon-back.png"/>
                    </template>
                  </template>
                  <span class="nqt-text">{{ $t("errorBook.next") }}</span>
                </button>
              </template>
            </div>
          </div>
        </template>
        <template v-if="materialInfo.materialList == null && mobile">
          <div class="curriculumPage_right">
            <div class="no--data">
              <img src="../../../static/images/noresult.jpg"/>
              <div class="no--btn--data">
                <el-button type="primary" @click="goto_lesson">{{ $t("common.returnButton") }}</el-button>
                <el-button type="primary" @click="tooggleMenuMobile()">{{ $t("read.catalogue") }}</el-button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="nqt--hidden" v-if="showLoadingFlg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;
import nqtPdf from "./nqtPdf";
import loading from "@/components/loading/loading";
import { mapMutations } from "vuex";

export default {
  components: {
    pdf: nqtPdf,
    loading,
  },
  name: "lesson",
  data() {
    return {
      disableMenu: false,
      showM3u8: false,
      showLoadingFlg: false,
      loading: false,
      handleSend: true,
      isContent: true,
      loadContent: true,
      loadControl: false,
      userId: null,
      value: 0,
      percent: 0,
      step: 20,
      courseName: null,
      materialInfo: {},
      materialPath: null,
      materialVideoPath: null,
      item_show: this.$CONST.VIDEO.CONTENT_TYPE.MENU,
      note: "",
      firstNote: "",
      data: [],
      isPage: 1,
      oldPage: 1,
      jumpPageNum: 0,
      pageCount: 0,
      phaseActive: 0,
      nqtCount: 0,
      pageReal: 0,
      activeID: null,
      activeMenu: null,
      message: null,
      chats: [],
      pdfs: [],
      maxSelect: [],
      pagination: [],
      showControl: true,
      noEventOnTap:  false,
      videoPrev: null,
      scale: 1,
      firstScale: 1,
      orientation: 0,
      hZ: true,
      pathIMG: null,
      playerOptions: {
        overNative: true,
        autoplay: false,
        controls: true,
        techOrder: ['html5'],
        html5: { hls: { withCredentials: false } },
        playbackRates: [0.5, 0.75, 1.0, 1.5, 1.75, 2.0],
        sources: [
          {
            withCredentials: false,
            type: 'application/x-mpegURL',
            src: ''
          }
        ],
        poster: '/static/images/logo.png'
      },
      itemCourseGetCourseMaterialNew: [],
    };
  },
  computed: {
    mobile () {
        return this.$store.getters['header/mobile'];
    }
  },
  async updated () {},
  destroyed () {
    if (this.note != this.firstNote) {
      this.$confirm(this.$t("js.confirmSaveNotes"),
        {cancelButtonClass: "btn-nqt---show"}
      ).then(() => {this.saveNote()}).catch(() => {});
      return
    }
  },
  watch: {
    disableMenu(value) {
      this.$refs.pdf[0].reload();
    },
    // 更改课程内容
    async phaseActive(value) {
      this.showM3u8 = false;
      let image = this.materialInfo.materialList.findIndex((item) => item.materialType == this.$CONST.VIDEO.MATERIAL.TYPE.IMG && value == item.id);
      if (image >= 0) {
        let data = {
          id: this.materialInfo.materialList[image].id,
          courseOutlineId: this.materialInfo.materialList[image].courseOutlineId,
          num: this.materialInfo.materialList[image].mnum,
          type: this.$CONST.VIDEO.MATERIAL.TYPE.IMG,
          index: image,
        };
        if (this.materialInfo.materialList[image].mnum != this.materialInfo.materialList[image].num) {
          this.updateStudyRecord(data);
        }
        this.showLoadingFlg = false;
        this.loadControl = true;
      }
      let video = this.materialInfo.materialList.findIndex((item) => item.materialType == this.$CONST.VIDEO.MATERIAL.TYPE.VIDEO && value == item.id);
      if (video >= 0) {
        let m3u8 = await this.getM3u8(value);
        this.playerOptions.sources[0].src = m3u8.materialPath;
        this.showM3u8 = true;
        let data = {
          id: this.materialInfo.materialList[video].id,
          courseOutlineId: this.materialInfo.materialList[video].courseOutlineId,
          num: this.materialInfo.materialList[video].num,
          mnum: this.materialInfo.materialList[video].mnum,
          type: this.$CONST.VIDEO.MATERIAL.TYPE.VIDEO,
          index: video,
        };
        this.videoPrev = data;
        this.showLoadingFlg = false;
        this.loadControl = true;
      }
      let pdf = this.materialInfo.materialList.findIndex((item) => item.materialType == this.$CONST.VIDEO.MATERIAL.TYPE.PDF && value == item.id && item.mnum == 1 && item.mnum != item.num);
      if (pdf >= 0) {
        let data = {
          id: this.materialInfo.materialList[pdf].id,
          courseOutlineId: this.materialInfo.materialList[pdf].courseOutlineId,
          num: this.materialInfo.materialList[pdf].mnum,
          type: 3,
          index: pdf,
        };
        // console.log("upd ------ watch");
        this.updateStudyRecord(data);
      } else {
        let pdfCheck = this.materialInfo.materialList.findIndex((item) => item.materialType == this.$CONST.VIDEO.MATERIAL.TYPE.PDF && value == item.id);
        if (pdfCheck >= 0) {
          if (this.materialInfo.materialList[pdfCheck].num == 0) {
            let data = {
              id: this.materialInfo.materialList[pdfCheck].id,
              courseOutlineId: this.materialInfo.materialList[pdfCheck].courseOutlineId,
              num: 1,
              type: 3,
              index: pdfCheck,
            };
            // console.log("upd ------ watch");
            this.updateStudyRecord(data);
          }
        }
      }
      let vDC = this.materialInfo.materialList.findIndex((item) => item.materialType != this.$CONST.VIDEO.MATERIAL.TYPE.VIDEO && value == item.id);
      if (vDC >= 0) {
        this.videoPrev = null;
      }
    },
    isPage (value, old) {
      this.oldPage = old;
    },
    item_show(value) {
      if (value == this.$CONST.VIDEO.CONTENT_TYPE.MESSENGER) {
        this.saveTimeSeenComment();
      }
    },
    $route(to, form) {
      this.outlineInfo = eval("(" + to.query.outlineInfo + ")");
      this.outlineInfo = JSON.parse(JSON.stringify(this.outlineInfo));
      this.activeID = this.outlineInfo.activeID;
      this.activeMenu = this.outlineInfo.activeMenu;
      this.getData(this.activeID, true);
      this.saveTimeSeenComment();
    }
  },
  created() {
      this.$autoLogin().then(
          () => {
            this.userId = this.$attrs.userId || window.sessionStorage.getItem("id");
          },
          () => {
            this.$router.push({
                path: "/home",
            });
          }
      );
  },
  mounted() {
    
    // 获取用户登录信息
    this.userId = window.sessionStorage.getItem("id");
    this.outlineInfo = eval("(" + this.$route.query.outlineInfo + ")");
    this.outlineInfo = JSON.parse(JSON.stringify(this.outlineInfo));

    // 获取第一次显示的商品信息
    this.activeID = this.outlineInfo.activeID;
    this.activeMenu = this.outlineInfo.activeMenu;

    // 移除手机中的菜单栏显示
    document.getElementsByTagName("body")[0].classList.remove("active-curri");
            
    const self = this;
    function doOnOrientationChange() {
      setTimeout(() => {
        self.value = 0;
        self.orientation = window.orientation;
      }, 500);
    }
    
    window.addEventListener('orientationchange', doOnOrientationChange);
    
    // 如果需要，初始执行
    doOnOrientationChange();
    

    // 第一次运行数据
    this.init();
  },
  methods: {
    getScale: function (zoom) {
      let scale = 1;
      switch (zoom) {
        case 20:
          scale = 2;
          break;
        case 40:
          scale = 2.25;
          break;
        case 60:
          scale = 2.5;
          break;
        case 80:
          scale = 2.75;
          break;
        case 100:
          scale = 3;
          break;
        default:
          break;
      }
      return scale;
    },
    getM3u8: function (id) {
      return new Promise((resolve, reject) => {
        this.$api
        .post("/courseStudy/getCourseMaterialObject", {
          courseMaterialId: id
        })
        .then((response) => {
          resolve(response.data);
        }).catch( err => {
          reject(err.response);
        });
      });
    },
    onPlayerReadied() {
      // console.log(`Load video completed !!!`);
    },
    // 检查上一个视频是否已经完成学习
    async onTimeupdate(e) {
      // console.log('time: ', e.cache_.currentTime);
      if (this.videoPrev != null) {
        let time = Math.ceil(e.cache_.currentTime);
        time = time >= this.videoPrev.mnum ? this.videoPrev.mnum : time;
        if (time >= 0 && time > this.videoPrev.num && this.videoPrev.num <= this.videoPrev.mnum) {
          this.videoPrev.num = time;
          let updateVideo = await this.updateNum(this.videoPrev).catch(err => {
            console.log(`-- error: Can't update !`);
          });
          this.materialInfo.materialList[this.videoPrev.index].num = parseInt(time);
        } 
      }
    },
    init: function () {
      this.getDataMenu();
      this.getData(this.activeID, true);
      // console.log(`item: ${this.outlineInfo.item}`);
      if (this.outlineInfo.item != null && this.outlineInfo.item != undefined && this.outlineInfo.item == this.$CONST.VIDEO.CONTENT_TYPE.MESSENGER) {
        if (this.mobile) {
          this.isContent = false;
          document.getElementsByTagName("body")[0].classList.toggle("active-curri");
        }
        this.showBoxMessage();
      }
    },
    showBoxMessage: function () {
      this.item_show = this.$CONST.VIDEO.CONTENT_TYPE.MESSENGER;
      setTimeout(() => {
        $(".chat-box").animate({scrollTop: $('.chat-box').prop("scrollHeight")}, 1000);
      }, 100);
    },
    loopPdf: async function (data) {
      data.forEach((item, i) => {
        let n = 1;
        if (item.materialType == this.$CONST.VIDEO.MATERIAL.TYPE.PDF) {
          n = item.mnum;
        }
        this.pdfs.push({
          index: i,
          phaseActive: item.id,
          type: item.materialType,
          count: n,
        });
      });
      this.pdfs = this.pdfs.sort((a, b) => parseFloat(a.index) - parseFloat(b.index));
      this.pdfs.forEach((item, i) => {
        let length = this.pagination.length;
        let begin = length + 1;
        let end = item.count + length;
        let n = 0;
        for (begin; begin <= end; begin++) {
          n += 1;
          this.pagination.push({
            phaseActive: item.phaseActive,
            page: begin,
            pageReal: n,
          });
        }
      });
      this.pageCount = this.pagination.length;
    },
    // 更新按item学习的页面
    updateNum: function (data) {
      return new Promise((resolve, reject) => {
        this.$api
        .post("/courseStudy/updateScheduleStudyRecord", {
          materialId: data.id,
          courseOutlineId: data.courseOutlineId,
          num: data.num,
          isCommitExam: true
        })
        .then((response) => {
          resolve(true);
        }).catch( err => {
          reject(err.response);
        });
      });
    },
    // Quay về trang mục lục
    goto_lesson: function () {
      if (this.note != this.firstNote) {
        this.$confirm(this.$t("js.confirmSaveNotes"),
          {cancelButtonClass: "btn-nqt---show"}
        ).then(() => {this.saveNote()}).catch(() => {});
        return
      }
      let outlineInfo = {
        courseId: this.outlineInfo.courseId,
        courseName: this.outlineInfo.courseName,
      };
      this.$router.push({
        path: "schedule/schedule_curriculum",
        query: {
          outlineInfo: JSON.stringify(outlineInfo),
        },
      });
    },
    // Đóng mở menu trong mobile
    tooggleMenuMobile: function () {
      this.isContent = !this.isContent;
      document.getElementsByTagName("body")[0].classList.toggle("active-curri");
    },
    notClickRight: function () {
      // console.log("Không được click !!!");
     return false;
    },
    // Lấy tổng số trang được xem
    getMaxSelect: function (data) {
      let result = [];
      let ctn = true;
      data.forEach((item, i) => {
        if (ctn) {
          if (item.materialType == this.$CONST.VIDEO.MATERIAL.TYPE.PDF) {
            let length = result.length;
            let begin = length + 1;
            let end = item.num + length;
            for (begin; begin <= end; begin++) {
              result.push(begin);
            }
          } else {
            result.push(result.length + 1);
            if (item.num < item.mnum) {
              ctn = false;
            };
          }
        }
      });
      result = result.length > 0 ? result : [1];
      return result;
    },
    // 获取课程信息
    getData: async function (activeID, type) {
      const self = this;
      var getDataLoadPage = await this.getDataLoadPage(activeID, type);
      return new Promise((resolve, reject) => {
        Promise.all(getDataLoadPage.materialList.map(item => {
            return self.loopImage(item);
        })).then(function(results) {
            resolve(true);
        })
      });
    },
    // Lấy thông tin của bài học
    getDataLoadPage: function (activeID, type) {
      this.pdfs = [];
      this.pagination = [];
      // Ẩn content trước khi load
      this.showLoadingFlg = true;
      this.showControl = true;
      this.loadContent = false;
      this.loadControl = false;
      return new Promise((resolve, reject) => {
        this.$api
        .post("/courseStudy/getScheduleCourseMaterialNew", {
            courseOutlineId: activeID,
            languageType: this.$lang(),
        })
        .then((response) => {
          this.note = null;
          // Reload data chat, note
          this.getNote();
          this.getMessages();
          if (response.data.materialList == null || response.data.materialList.length == 0) {
            this.showControl = false;
            this.showLoadingFlg = false;
            this.$confirm(window.vm.$i18n.t("new.title88"),
              window.vm.$i18n.t("new.title86"),
              {cancelButtonClass: "btn-nqt---show"}
            ).then(() => {}).catch(() => {});
            return;
          }
          this.materialInfo = response.data;
          this.itemCourseGetCourseMaterialNew = response.data.materialList;
          /// #53
          if(this.materialInfo.materialList.length>0){
            this.materialInfo.materialList.forEach(value => {
              this.$api
              .post("/courseStudy/updateAccessInfo", {
                companyId : window.sessionStorage.getItem("companyId"),
                contentID: value.id,
              })
              .then((response) => {});
            });
          }
          /// #53
          let data = this.materialInfo.materialList != null && this.materialInfo.materialList.length ? this.materialInfo.materialList : [];
          this.loopPdf(data);
          this.maxSelect = this.getMaxSelect(data);
          this.isPage = this.maxSelect.length > 0 ? this.maxSelect.length : 1;
          this.isPage = this.maxSelect.length == this.pagination.length ? 1 : this.isPage;
          this.isPage = !type ? 1 : this.isPage;
          let key = this.pagination.findIndex((x) => x.page == this.isPage);
          this.pageReal = this.pagination[key].pageReal;
          if (this.phaseActive == this.pagination[key].phaseActive) {
            this.showLoadingFlg = false;
          }
          this.phaseActive = this.pagination[key].phaseActive;
          this.activeMenu = response.data.l1;
          this.loadContent = true;
          resolve(response.data);
        })
        .catch((err) => {
            reject(err.response);
        });
      });
    },
    //// blob image
    loopImage: function(data){
      if (data.materialType=="3") {
        return new Promise((resolve) => {
            this.$api.post("/courseStudy/getCourseMaterialObject", {
                courseMaterialId: data.id,
            })
            .then((response) => {
                const blob = this.dataURItoBlobImage(response.data.blob);
                const urls = URL.createObjectURL(blob);
                data.materialPath = urls;
                resolve(urls);
                // return urls;
            })
            .catch((err) => {});
        });
      }
    },
    // 传播菜单栏信息
    getDataMenu: function () {
      let param = {
        courseId: this.outlineInfo.courseId,
        userId: null,
      };
      this.$api
        .post("/courseStudy/getScheduleCourseSubOutlineListByTopOutline", param)
        .then((response) => {
          let dataCp = response.data;
          dataCp.forEach((item, i) => {
            let keyParent = dataCp.findIndex((x) => x.id == item.parentId);
            if (keyParent >= 0) {
              dataCp[keyParent].thirdOutlineList = dataCp[keyParent].thirdOutlineList == null ? [] : dataCp[keyParent].thirdOutlineList;
              dataCp[keyParent].thirdOutlineList.push(item);
            }
            if (item.score=="—") {
              if (item.isExercise==0) {
                item["scoreNew"] = 100;
              } else {
                item["scoreNew"] = 0;
              }
            } else {
              item["scoreNew"] = parseInt(item.score);
            }
          });
          this.data = dataCp.filter((x) => {
            return x.level == 1;
          });
        })
        this.$api
        .post("/courseStudy/getScheduleCourseMaterialNew", {
          courseOutlineId: this.activeID,
          languageType: this.$lang(),
        })
        .then((response) => {
            this.itemCourseGetCourseMaterialNew = response.data.materialList;
        })
        .catch(() => {});
    },
    toggleClass(event, parentID) {
      event.target.classList.toggle("caret-down");
      event.target.nextElementSibling.classList.toggle("active");
      this.activeMenu = parentID;
    },
    // Chuyển đến bài học
    jumpToLesson: function (item1, item2, item3, item4, item5, data) {
      if (this.note != this.firstNote) {
        this.$confirm(this.$t("js.confirmSaveNotes"),
          {cancelButtonClass: "btn-nqt---show"}
        ).then(() => {this.saveNote()}).catch(() => {});
        return
      }
      this.tooggleMenuMobile();
      this.activeID = data.id;
      this.activeMenu = item1.id;
      this.getData(data.id, true);
    },
    closeModal: function () {
      this.noEventOnTap = false;
    },
    nextPage: function () {
      if (this.videoPrev != null) {
        let keyVideo = this.materialInfo.materialList.findIndex((x) => x.id == this.videoPrev.id);
        if (keyVideo >= 0) {
          if (this.materialInfo.materialList[keyVideo].materialType == this.$CONST.VIDEO.MATERIAL.TYPE.VIDEO && this.materialInfo.materialList[keyVideo].num < this.materialInfo.materialList[keyVideo].mnum) {
            this.noEventOnTap = true;
            setTimeout(() => {
              this.$confirm(this.$t('new.title87'),
                window.vm.$i18n.t("new.title86"),
                {cancelButtonClass: "btn-nqt---show"}
              ).then(() => {
                this.closeModal();
              }).catch(() => {
                this.closeModal();
              });
            }, 200);
            return;
          }
        }
      }
      let key = this.pagination.findIndex((x) => x.page == this.isPage + 1);
      if (key >= 0) {
        this.isPage += 1;
        this.value = 0;
        let keyMaterial = this.materialInfo.materialList.findIndex((x) => x.id == this.pagination[key].phaseActive);
        if (this.materialInfo.materialList[keyMaterial].materialType == this.$CONST.VIDEO.MATERIAL.TYPE.PDF) {
          if (this.materialInfo.materialList[keyMaterial].num != 0 && (this.pagination[key].pageReal <= this.materialInfo.materialList[keyMaterial].mnum && this.pagination[key].pageReal > this.materialInfo.materialList[keyMaterial].num)) {
            let data = {
              id: this.materialInfo.materialList[keyMaterial].id,
              courseOutlineId: this.materialInfo.materialList[keyMaterial].courseOutlineId,
              num: this.pagination[key].pageReal,
              type: 1,
              index: keyMaterial,
            };
            // console.log("upd ------ next");
            this.updateStudyRecord(data);
          }
          // console.log('next page !!');
          if (this.pagination[key].phaseActive == this.phaseActive) {
            this.$refs.pdf[0].jump(parseInt(this.pagination[key].pageReal));
          } else {
            this.showLoadingFlg = true;
            this.phaseActive = this.pagination[key].phaseActive;
            this.loadContent = false;
            this.$nextTick(() => {
              this.loadContent = true;
              this.pageReal = this.pagination[key].pageReal;
            });
          }
        } else {
          this.showLoadingFlg = true;
          this.phaseActive = this.pagination[key].phaseActive;
          this.loadContent = false;
          this.$nextTick(() => {
            this.loadContent = true;
          });
        }
      } else {
        // console.log('next phase !!');
        if (this.note != this.firstNote) {
          this.$confirm(this.$t("js.confirmSaveNotes"),
            {cancelButtonClass: "btn-nqt---show"}
          ).then(() => {this.saveNote()}).catch(() => {});
          return
        }
        this.showLoadingFlg = true;
        this.getData(this.materialInfo.nextOutlineId, false);
        this.activeID = this.materialInfo.nextOutlineId;
      }
    },
    prevPage: function () {
      let key = this.pagination.findIndex((x) => x.page == this.isPage - 1);
      if (key >= 0) {
        this.isPage -= 1;
        this.value = 0;
        let keyMaterial = this.materialInfo.materialList.findIndex((x) => x.id == this.pagination[key].phaseActive);
        if (this.materialInfo.materialList[keyMaterial].materialType == this.$CONST.VIDEO.MATERIAL.TYPE.PDF) {
          if ( this.materialInfo.materialList[keyMaterial].num == 0 || (this.pagination[key].pageReal <= this.materialInfo.materialList[keyMaterial].mnum && this.pagination[key].pageReal > this.materialInfo.materialList[keyMaterial].num)) {
            let data = {
              id: this.materialInfo.materialList[keyMaterial].id,
              courseOutlineId: this.materialInfo.materialList[keyMaterial].courseOutlineId,
              num: this.pagination[key].pageReal,
              type: 1,
              index: keyMaterial,
            };
            // console.log("upd ------ prev");
            this.updateStudyRecord(data);
          }
          // console.log('prev page !!');
          if (this.pagination[key].phaseActive == this.phaseActive) {
            this.$refs.pdf[0].jump(parseInt(this.pagination[key].pageReal));
          } else {
            this.showLoadingFlg = true;
            this.phaseActive = this.pagination[key].phaseActive;
            this.loadContent = false;
            this.$nextTick(() => {
              this.loadContent = true;
              this.pageReal = this.pagination[key].pageReal;
            });
          }
        } else {
          this.showLoadingFlg = true;
          this.phaseActive = this.pagination[key].phaseActive;
          this.loadContent = false;
          this.$nextTick(() => {
            this.loadContent = true;
          });
        }
      } else {
        // console.log('prev phase !!');
        if (this.note != this.firstNote) {
          this.$confirm(this.$t("js.confirmSaveNotes"),
            {cancelButtonClass: "btn-nqt---show"}
          ).then(() => {this.saveNote()}).catch(() => {});
          return
        }
        this.showLoadingFlg = true;
        this.getData(this.materialInfo.preOutlineId, false);
        this.activeID = this.materialInfo.preOutlineId;
      }
    },
    jumpPage: function () {
      if (this.isPage > this.pageCount) {
        this.$el_alert_type(window.vm.$i18n.t("js.mostPage"), "warning");
        return;
      } else if (this.isPage <= 0) {
        this.$el_alert_type(window.vm.$i18n.t("js.leastPage"), "warning");
        return;
      }
      setTimeout(() => {
        let key = this.pagination.findIndex((x) => x.page == this.isPage);
        this.value = 0;
        let keyMaterial = this.materialInfo.materialList.findIndex((x) => x.id == this.pagination[key].phaseActive);
        if (this.materialInfo.materialList[keyMaterial].materialType == this.$CONST.VIDEO.MATERIAL.TYPE.PDF) {
          if (this.materialInfo.materialList[keyMaterial].num == 0 || (this.pagination[key].pageReal <= this.materialInfo.materialList[keyMaterial].mnum && this.pagination[key].pageReal > this.materialInfo.materialList[keyMaterial].num)) {
            let data = {
              id: this.materialInfo.materialList[keyMaterial].id,
              courseOutlineId: this.materialInfo.materialList[keyMaterial].courseOutlineId,
              num: this.pagination[key].pageReal,
              type: 1,
              index: keyMaterial,
            };
            this.updateStudyRecord(data);
          }
          if (this.pagination[key].phaseActive == this.phaseActive) {
            this.$refs.pdf[0].jump(parseInt(this.pagination[key].pageReal));
          } else {
            this.showLoadingFlg = true;
            this.phaseActive = this.pagination[key].phaseActive;
            this.loadContent = false;
            this.$nextTick(() => {
              this.loadContent = true;
              this.pageReal = this.pagination[key].pageReal;
            });
          }
        } else {
          this.showLoadingFlg = true;
          this.phaseActive = this.pagination[key].phaseActive;
          this.loadContent = false;
          this.$nextTick(() => {
            this.loadContent = true;
          });
        }
      }, 10);
    },
    // Chuyển đến trang bài tập
    goExc: function () {
      let checkStatusLearning = false;
      if (this.itemCourseGetCourseMaterialNew) {
        this.itemCourseGetCourseMaterialNew.forEach(element => {
          if(this.materialInfo.courseOutlineId==element.courseOutlineId){
            if (element.learningState!=0) {
              checkStatusLearning = true;
            }
          }
        });
      }
      if (checkStatusLearning) {
        this.$message.warning(window.vm.$i18n.t('new.title104'));
        return;
      }
      let outlineInfo = {
        courseId: this.outlineInfo.courseId, 
        courseName: this.outlineInfo.courseName,
        topId: this.materialInfo.l1 != undefined && this.materialInfo.l1 != null ? this.materialInfo.l1 : null,
        secondId: this.materialInfo.l2 != undefined && this.materialInfo.l2 != null ? this.materialInfo.l2 : null,
        thirdId: this.materialInfo.l3 != undefined && this.materialInfo.l3 != null ? this.materialInfo.l3 : null,
        fourthId: this.materialInfo.l4 != undefined && this.materialInfo.l4 != null ? this.materialInfo.l4 : null,
        fifthId: this.materialInfo.l5 != undefined && this.materialInfo.l5 != null ? this.materialInfo.l5 : null,
        courseOutlineId: this.materialInfo.courseOutlineId,
        secondChapterName: this.materialInfo.chapterName,
        level: this.materialInfo.level,
        type: 0,
        nextL1: this.materialInfo.nextL1 != undefined && this.materialInfo.nextL1 != null ? this.materialInfo.nextL1 : null,
        nextL2: this.materialInfo.nextL2 != undefined && this.materialInfo.nextL2 != null ? this.materialInfo.nextL2 : null,
        nextL3: this.materialInfo.nextL3 != undefined && this.materialInfo.nextL3 != null ? this.materialInfo.nextL3 : null,
        nextL4: this.materialInfo.nextL4 != undefined && this.materialInfo.nextL4 != null ? this.materialInfo.nextL4 : null,
        nextL5: this.materialInfo.nextL5 != undefined && this.materialInfo.nextL5 != null ? this.materialInfo.nextL5 : null,
        nextLevel: this.materialInfo.nextLevel,
        nextLevelName: this.materialInfo.nextLevelName,
        endFlag: this.materialInfo.nextOutlineId == null ? 1 : 0,
      };
      this.$router.push({
        path: "schedule/schedule_task_answer",
        query: {
          outlineInfo: JSON.stringify(outlineInfo),
        },
      });
    },
    updateStudyRecord: async function (data) {
      let update = await this.updateNum(data).catch(err => {
        console.log(`-- error: Can't update !`);
      });
      this.materialInfo.materialList[data.index].num = parseInt(data.num);
      this.maxSelect = this.getMaxSelect(this.materialInfo.materialList);
      // console.log(`update: ${update}`);
      this.getDataMenu();
    },
    saveNote: function () {
      if (this.note == null) {
        this.note = "";
      }
      let array = this.note.split("\n");
      let rows = 0;
      array.forEach((obj) => {
        let chinese = obj.match(/[\u4e00-\u9fa5。，？”“《》：！——-、]/g);
        let chineselength = chinese ? chinese.length : 0;
        let currentRows = Math.ceil((obj.length + chineselength) / 25);
        rows += currentRows;
      });
      if (rows > 40) {
        this.$el_alert_type(window.vm.$i18n.t("js.wordMore"), "warning");
        return;
      }
      this.$api
        .post("/courseStudy/getMaterialNoteExists", {
          materialId: this.activeID,
        })
        .then((response) => {
          let url = response.data == 0 ? "/courseStudy/insertMaterialNote" : "/courseStudy/updateMaterialNote";
          this.$api
            .post(url, {
              materialId: this.activeID,
              noteContent: this.note,
            })
            .then(() => {
              this.firstNote = this.note;
              this.$el_alert_type(
                window.vm.$i18n.t("js.saveSuccess"),
                "success"
              );
            });
        });
    },
    getNote: function () {
      this.$api
        .post("/courseStudy/getMaterialNote", {
          materialId: this.activeID,
        })
        .then((response) => {
          this.note = response.data[0] ? response.data[0].noteContent : this.note;
          this.firstNote = this.note;
        });
    },
    getMessages: function () {
      const self = this;
      this.$api
        .post("/courseStudy/getCourseMaterialCommentList", {
          courseMaterialId: this.activeID,
        })
        .then((response) => {
          let data = response.data.length ? response.data : [];
          data.forEach((item, i) => {
            item['path'] = this.pathIMG + item.portraitPath;
          });
          this.chats = data.reverse();
          setTimeout(() => {
            this.handleSend = true;
          }, 2000);
          $(".chat-box").animate({scrollTop: $('.chat-box').prop("scrollHeight")}, 1000);
        });
    },
    appendLeadingZeroes: function (n) {
        if(n <= 9){
            return "0" + n;
        }
        return n
    },// Lấy danh sách thông báo comment
    getCourseCommentListNew: function (userId) {
        return new Promise((resolve, reject) => {
            this.$api
                .post("/courseStudy/getCourseCommentListNew", {
                    userId: userId,
                    languageType: this.$lang(),
                })
                .then((response) => {
                    response.data = response.data.sort(function (a, b) {
                        return b.lessonId - a.lessonId;
                    });
                    let result = response.data.filter((item) => item.status == 0);
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err.response);
                });
        });
    },
    saveNotie: function (timeSeen) {
      return new Promise((resolve, reject) => {
        this.$api
        .post("/courseStudy/getTimeSeenComment", {
          userId : this.userId,
          courseId : this.outlineInfo.courseId,
          lessonId : this.activeID,
          timeSeen: timeSeen
        })
        .then((response) => {
          resolve(true)
        })
        .catch((err) => {});
      });
    },
    getNumberOfUnreadComment: function () {
      let userId = window.sessionStorage.getItem("id");
      // this.$api
      // .post("/courseStudy/getNumberOfUnreadComment", {
      //     languageType: this.$lang(),
      //     targetDataType: 1,
      // })
      // .then((response) => {
      //   this.setTotalComment(response.data);
      // })
      this.$api
      .post("/courseStudy/getCourseCommentListNew", {
          userId: userId,
          languageType: this.$lang(),
      })
      .then((response) => {
          this.setTotalComment(response.data.length);
      })
      .catch((err) => {
      });
    },
    saveTimeSeenComment: async function () {
      let currentDatetime = new Date()
      let timeSeen = currentDatetime.getFullYear() + "-" + this.appendLeadingZeroes(currentDatetime.getMonth() + 1) + "-" + this.appendLeadingZeroes(currentDatetime.getDate()) + " " + this.appendLeadingZeroes(currentDatetime.getHours()) + ":" + this.appendLeadingZeroes(currentDatetime.getMinutes()) + ":" + this.appendLeadingZeroes(currentDatetime.getSeconds());
      await this.saveNotie(timeSeen);
      this.getNumberOfUnreadComment();
    },
    ...mapMutations("header", ["setTotalComment"]),
    sendMessageEnter: function () {
      const self = this;
      let text = self.message;
      self.message = null;
      return new Promise((resolve, reject) => {
        self.$api
        .post("/courseStudy/insertCourseMaterialComment", {
          courseMaterialId: self.activeID,
          commentContent: text,
          createBy: self.userId,
        })
        .then((response) => {
          resolve(true)
        })
        .catch((err) => {});
      });
    },
    sendMessage: async function () {
      if (this.message == null || this.message == "") return;
      if (!this.handleSend) return;
      this.handleSend = false;
      let ins = await this.sendMessageEnter();
      this.getMessages();
    },
    nqtLoadPDF: function (status) {
      if (!status) {
        this.showControl = false;
        this.$confirm(window.vm.$i18n.t("new.title89"),
          window.vm.$i18n.t("new.title86"),
          {cancelButtonClass: "btn-nqt---show"}
        ).then(() => {}).catch(() => {});
      }
      this.showLoadingFlg = false;
      this.loadControl = true;
      this.value = 0;
    },
    onTap: function (e) {
      let widthScreen = screen.width;
      let position = e.clientX < widthScreen/2 ? "left" : "right";
      // console.log(position);
      if (e.clientX < widthScreen/2) {
        if (this.materialInfo.preOutlineId != null || this.isPage != 1) {
          this.prevPage();
        }
      } else {
        if (this.materialInfo.nextOutlineId != null || this.isPage < this.pageCount) {
          this.nextPage();
        }
      }
    }
  }
};
</script>
<style scoped>
  .nqt_disableMenu {
    width: 100% !important;
  }
  .curriculum_box_main {
    padding: 0;
  }
  .nqt-result-pdf {
    object-fit: none;
    width: 100%;
  }
  .hiddenControl {
    display: none;
  }
  .nqt--hidden {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    z-index: 100000000;
    background-color: transparent;
  }
  @media (max-width: 834px) {
    .active-curri .curriculumPage_right {right: 0}
  }
  .pgn {
    margin-right: 10px;
    line-height: 20px;
    font-size: 15px;
  }
  .caret.caret-down {
    text-transform: none !important;
  }
  .caret-down.caret {
    color: #000000 !important;
  }
  .nqtLoaderCss {
    background: oldlace;
  }
  /* Chat */
  .messenger_fill,
  .messenger_fill .chat-box {
    width: 100%;
    height: calc(100vh - 153px);
  }
  .messenger_fill .chat-box {
    position: relative;
    overflow: auto;
  }
  .fab_field {
    width: 100%;
    display: flex;
    border-top: 1px solid #eee;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 50px;
  }
  .messenger_fill .chat-box .content-message {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .n-ms {
    padding: 5px;
    height: auto;
    min-width: 177px;
    border-radius: 5px;
    margin: 10px 5px;
    overflow: auto;
    float: left;
    width: 50% !important;
  }
  .f-left .n-ms {
    background: #535c68;
  }
  .f-teacher .n-ms {
    background: #0071c5;
  }
  .f-right .n-ms {
    background: #44bd32;
  }
  .f-left .n-ms::before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #535c68;
    top: 13px;
    left: 37px;
  }
  .f-teacher .avt {
    float: left;
    margin-left: 5px;
    margin-right: 0;
  }
  .f-teacher .n-ms::before {
    content: "";
    position: absolute;
    top: 13px;
    left: 37px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #0071c5;
  }
  .f-right .n-ms {
    float: right;
  }
  .f-right .n-ms::after {
    content: "";
    position: absolute;
    top: 13px;
    right: 37px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid #44bd32;
  }
  .messenger_fill .chat-box .content-message .msg p {
    color: #fff;
    font-size: 0.7em;
    float: left;
    text-align: left;
    margin: -0.25em 2em;
    font-weight: 0.7em;
    width: 100px;
  }
  .messenger_fill .chat-box .content-message .msg .name {
    color: #fff;
    font-size: 1em;
  }
  .messenger_fill .chat-box .content-message .msg .message {
    color: #fff;
    font-size: 0.7em;
    margin: 0 2.8em;
  }
  .chat_field {
    position: relative;
    margin: 5px;
    width: calc(100% - 55px);
    line-height: 30px;
    font-size: 12px;
    font-weight: 500;
    color: #4b4b4b;
    border: none !important;
    outline: none !important;
    display: inline-block;
  }
  .chat_field.chat_message {
    resize: none;
    font-size: 15px;
    font-weight: 400;
  }
  .fab_field .send {
    height: 46px;
    background: transparent;
    border: none;
    transform: rotate(180deg) !important;
    position: relative !important;
    display: flex;
  }
  .avt {
    width: 32px;
    height: 32px;
    background: aliceblue;
    color: transparent;
    border-radius: 50%;
    float: right;
    margin-right: 5px;
    overflow: hidden;
    margin-top: 10px;
  }
  .avt img {
    width: 32px;
    height: 32px;
    object-fit: cover;
  }
  .f-left .avt {
    float: left;
    margin-left: 5px;
    margin-right: 0;
  }
  .nav_ul_li {
    width: 33.33% !important;
    height: 38px;
  }
  /*  */
  .loading--lesson {
    position: absolute !important;
  }
  .curriculum_box {
    position: relative;
    overflow: auto;
  }
  .btn--none {
    color: black !important;
  }
  .closeMenu {
    display: none;
  }
  .lesson_page_pdf button {
    margin: auto;
    background: transparent;
    color: #72727260;
    border: 2px #72727260 solid;
    border-radius: 5px;
    padding: 5px;
    transition: 0.5s ease;
  }
  .lesson_page_pdf span.pages {
    padding-top: 8px;
  }
  .lesson_page_pdf button:hover {
    color: #fff;
    background: #0071c5;
  }
  .lesson_page_pdf span input {
    width: 40px;
    height: 29px;
    border-radius: 5px;
    outline: none;
    border: 2px #c3bbbb solid;
    margin: 0 5px;
    text-align: center;
    font-size: 14px;
    color: #414141;
  }
  .lesson_page_pdf span input:focus {
    border: 1px black solid !important;
  }
  /* left */
  .curriculumPage_main {
    margin-top: 20px;
    position: relative;
    display: -webkit-box;
  }
  .curriculumPage_main_page {
    min-width: 1200px;
    width: 100%;
    margin: 0 auto;
    display: flex;
  }
  .curriculumPage_main .curriculumPage_main_left {
    width: 400px;
  }
  .curriculumPage_main .curriculumPage_main_left .catalogue_box {
    padding: 10px 10px 0;
  }
  .curriculumPage_main .curriculumPage_main_left .notebook_catalogue {
    width: 100%;
    height: calc(100% - 0px);
    margin-top: 0px;
    border-radius: 5px;
    box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.5);
    position: relative;
  }
  .curriculumPage_main .curriculumPage_main_left .notebook_catalogue ul.nav_ul {
    position: relative;
    zoom: 1;
    overflow: hidden;
  }
  .curriculumPage_main
    .curriculumPage_main_left
    .notebook_catalogue
    ul.nav_ul
    li {
    width: 49.8%;
    margin-top: 5px;
    font-size: 14px;
    text-align: center;
    float: left;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
    transition: 0.5s ease;
    border-bottom: 2px #72727260 solid;
    padding: 10px;
  }
  .curriculumPage_main
    .curriculumPage_main_left
    .notebook_catalogue
    ul.nav_ul
    li
    span {
    font-size: 14px;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
    cursor: pointer;
    color: black;
    transition: 0.5s ease;
  }
  .curriculumPage_main
    .curriculumPage_main_left
    .notebook_catalogue
    ul
    li
    span:hover {
    color: #0071c5 !important;
  }
  .curriculumPage_main .curriculumPage_main_left .notebook_catalogue_active {
    border-bottom: 2px #0071c5 solid !important;
  }
  .curriculumPage_main .curriculumPage_main_left .notebook_catalogue_active span {
    color: #0071c5 !important;
  }
  .curriculumPage_main
    .curriculumPage_main_left
    .notebook_catalogue
    .notebook_fill {
    min-height: 190px;
    height: calc(100% - 167px);
  }
  .curriculumPage_main .curriculumPage_main_left .notebook_input {
    width: 100%;
    height: 100%;
    margin: 10px 0;
    background-color: unset;
    border: 0;
    font-size: 14px;
    color: #000;
    font-weight: 200;
    font-style: normal;
    padding: 10px;
    box-sizing: boder-box;
  }
  .curriculumPage_main .curriculumPage_main_left .notebook_input:focus {
    border: 0 !important;
  }
  .curriculumPage_main .curriculumPage_main_left .save_btn {
    width: 100%;
    height: 60px;
    margin-top: 10px;
    text-align: center;
    border-top: 1px #0071c560 solid;
    position: absolute;
    bottom: 0;
  }
  .curriculumPage_main .curriculumPage_main_left .save_btn button {
    width: 80px;
    height: 30px;
    line-height: 12px;
    padding: 5px 10px 6px 10px;
    margin-top: 19px;
    font-size: 14px;
    transform: scale(0.9);
    -webkit-transform: scale(0.9);
    color: #0071c5;
    font-style: normal;
    background-color: unset;
    border-radius: 5px;
    border: 1px #0071c5 solid;
    -webkit-transition: 0.5s ease;
    transition: 0.5s ease;
  }
  .curriculumPage_main .curriculumPage_main_left .save_btn button:hover {
    background-color: #0071c5;
    color: #fff;
    transition: 0.5s ease;
  }
  .curriculumPage_main .curriculumPage_main_right {
    min-width: 820px;
    width: calc(100% - 355px);
    float: right;
  }
  .curriculumPage_right .curriculum_box {
    margin-top: 0;
    display: -webkit-flex;
    display: flex;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.5);
  }

  /* menu */
  .noTitle {
    color: #898f96d1;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .caret {
    cursor: pointer;
    user-select: none;
  }
  .caret::after {
    content: "\25B6";
    color: black;
    display: inline-block;
    margin-left: 6px;
  }
  .caret-down::after {
    transform: rotate(90deg);
  }
  .nested {
    display: none;
    padding-left: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .active {
    display: block;
    font-size: 14px;
  }
  .tb-week {
    position: absolute;
    right: 0;
    display: flex;
    width: 30%;
  }
  .tb-week img {
    padding: 5px;
    padding-right: 20px;
    position: relative;
    top: -5px;
    left: 34%;
    width: 50px;
    height: 30px;
  }
  .tb-week li {
    width: 39%;
    text-align: center;
  }
  .time {
    display: -webkit-box;
    display: -ms-flexbox;
    /* display: flex; */
    color: #fff;
    font-size: 11px;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: end;
    padding: 5px 5px 0 0;
  }
  .no-result-pdf {
    object-fit: none !important;
  }
  .nqt-zoom button {
    width: 54px;
    background-color: transparent;
    height: 51px;
    border-radius: 50%;
    cursor: pointer;
    margin: 10px;
    border-color: #0071c5;
  }
  .nqt-zoom button span{
    font-size: 30px;
    font-style: normal;
    color: #0071c5;
  }
  .nqt-zoom {
    position: absolute;
    display: grid;
    bottom: 70px;
    right: 30px;
    z-index: 10000000;
  }
  .btn-zoom-out.disable {
    cursor: not-allowed;
  }
  .btn-zoom-out.disable {
    cursor: not-allowed;
    border-color: #787c7e !important;
  }
  .h-z {
    color: #0071c5 !important;
  }
  .h-h {
    color: #414141 !important;
  }
  .nqt-zoom-mn .nqt-precent{
    margin-top: 10px;
    margin-left: 10px;
    width: 50px;
    text-align: Center;
    float: left;
    font-weight: bold;
    font-size: 14px;
    color: #0071c5;
  }
  .pages-number.nqt-zoom-mn {
    width: 100%;
    top: -35px;
  }
  .nqt-zoom-mn .el-slider {
    width: calc(100% - 200px);
    float: left;
    margin: 0 16px;
  }
  .nqt-zoom-mn .select-new {
    height: 24px!important;
    line-height: 24px!important;
    margin-left: 0;
    margin-top: 7px;
    width: 50px !important;
  }
  .nqt-zoom-mn .pgn {
    margin-top: 10px;
  }
  .noTitle .nqtCn {
    white-space: normal;
  }
  .curriculum_img video {
    cursor: pointer;
  }
  .curriculum_box::-webkit-scrollbar-thumb {
      background: #000;
  }
  .curriculum_box::-webkit-scrollbar {
      width: 15px !important;
  }
  /* m3u8 */
  .nqt_a_l {
    position: absolute;
    top: 50%;
    right: 5px;
    z-index: 9999999;
  }
  .nqt_a_r {
    position: absolute;
    top: 50%;
    left: 25px;
    z-index: 9999999;
  }
  .nqt_close_menu,
  .nqt_open_menu{
    font-size: 50px;
    font-weight: 700;
    background: #75686824;
    border: none;
  }
  .nqt_close_menu:hover,
  .nqt_open_menu:hover{
    background: #6aa0f024;
  }
  .no--data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%)
  }
  .no--btn--data {
    display: flex;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/schedule/video.vue